import has from 'has';
import 'edge/gw-portals-policytransaction-common-angular';
import 'conditional?if=endorsement-products&equals=BusinessOwners!edge/gw-portals-policytransaction-pc-bop-angular';
import 'conditional?if=renewal-products&equals=BusinessOwners!edge/gw-portals-policytransaction-renewal-bop-angular';
import 'conditional?if=endorsement-products&equals=CommercialProperty!edge/gw-portals-policytransaction-pc-cp-angular';
import 'conditional?if=renewal-products&equals=CommercialProperty!edge/gw-portals-policytransaction-renewal-cp-angular';
import 'edge/platform/widgets/time/module';

const lobModules = ['edge.transaction.common.app', 'edge.platform.widgets.ui.time'];

if (has('endorsement-products.CommercialProperty')) {
    lobModules.push('edge.transaction.pc.cp.app');
}

if (has('renewal-products.CommercialProperty')) {
    lobModules.push('edge.transaction.renewal.cp.app');
}

if (has('endorsement-products.BusinessOwners')) {
    lobModules.push('edge.transaction.pc.bop.app');
}

if (has('renewal-products.BusinessOwners')) {
    lobModules.push('edge.transaction.renewal.bop.app');
}

export default lobModules;